import { createAction } from 'typesafe-actions';

import { type PersonalShortcuts } from '../../models';

export const personalShortcutsRequested = createAction(
  'shortcuts/personalShortcutsRequested'
)();

export const personalShortcutsReceived = createAction(
  'shortcuts/personalShortcutsReceived'
)<PersonalShortcuts>();

export const personalShortcutsNotReceived = createAction(
  'shortcuts/personalShortcutsNotReceived'
)();
